import React, { Component } from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";
import hyperlinks from "../../../src/util/hyperlinks";

export default class MemberContactModal extends Component {
    render() {
        return (
            <Modal className="members-grid-modal" show={this.props.showModal} onHide={this.props.closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Only registered members may contact other members</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        If you are a registered member, please log in to get in touch with other members. If you are not yet a registered member, you may apply to become one of the following:
                    </p>

                    <Row>
                        <Col md={6}>
                            <p className="left-info">
                                Become a gold standard utility recognised for its innovation and performance.
                            </p>
                        </Col>
                        <Col md={6}>
                            <p className="right-info">
                                Help us celebrate outstanding achievement in the global water sector and drive performance across the sector.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Button href={hyperlinks["newMember"]}>Become a utility member</Button>
                        </Col>
                        <Col md={6}>
                            <Button href={hyperlinks["corporateMembership"]}>Become a corporate member</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/MemberContactModal.jsx.erb